import React from "react";
import { DealShowPage } from "./DealShowPage";

const DealList = React.lazy(() => import("./DealList"));

export default {
  list: DealList,
  show: DealShowPage,
  recordRepresentation: (record: any) =>
    record?.name ?? `Oportunidad #${record?.id}`,
};
